import {LabelsActionTypes, LabelsState, ImageData, TagName} from './types';
import {Action} from '../Actions';

const initialState: LabelsState = {
    activeImageIndex: null,
    activeLabelNameId: null,
    activeLabelType: null,
    activeLabelId: null,
    highlightedLabelId: null,
    imagesData: [],
    firstLabelCreatedFlag: false,
    labels: [],
    Tags: [],
    annotationCounts: [],
    UpdateSaveStatus: null,
    audioUrl: '',
    audioName:'',
    annotations: {},
    undoRedoByImage: {},
    undoIndexByImage: {},
    videoTrackingEnabled: false,
    pendingTrackId: null,
};

export function labelsReducer(
    state = initialState,
    action: LabelsActionTypes
): LabelsState {
    switch (action.type) {
        case Action.UPDATE_ACTIVE_IMAGE_INDEX: {
            return {
                ...state,
                activeImageIndex: action.payload.activeImageIndex
            }
        }
        case Action.UPDATE_ACTIVE_LABEL_NAME_ID: {
            return {
                ...state,
                activeLabelNameId: action.payload.activeLabelNameId
            }
        }
        case Action.UPDATE_ACTIVE_LABEL_ID: {
            return {
                ...state,
                activeLabelId: action.payload.activeLabelId
            }
        }
        case Action.UPDATE_HIGHLIGHTED_LABEL_ID: {
            return {
                ...state,
                highlightedLabelId: action.payload.highlightedLabelId
            }
        }
        case Action.UPDATE_ACTIVE_LABEL_TYPE: {
            return {
                ...state,
                activeLabelType: action.payload.activeLabelType
            }
        }
        case Action.UPDATE_IMAGE_DATA_BY_ID: {
            const trackUndo = action.payload.trackUndo !== false;
            const imageId = action.payload.id;
            const currentStack = state.undoRedoByImage[imageId] || [];
            const currentUndoIndex = state.undoIndexByImage[imageId] || 0;
            let nextUndoRedoByImage = state.undoRedoByImage;
            let nextUndoIndexByImage = state.undoIndexByImage;

            if (trackUndo) {
                const currentEntry = currentStack[currentUndoIndex] || null;
                if (!currentEntry || JSON.stringify(currentEntry) !== JSON.stringify(action.payload.newImageData)) {
                    const updatedStack = [
                        action.payload.newImageData,
                        ...currentStack.slice(currentUndoIndex, currentUndoIndex + 18),
                    ];
                    nextUndoRedoByImage = {
                        ...state.undoRedoByImage,
                        [imageId]: updatedStack,
                    };
                    nextUndoIndexByImage = {
                        ...state.undoIndexByImage,
                        [imageId]: 0,
                    };
                }
            }

            return {
                ...state,
                imagesData: state.imagesData.map((imageData: ImageData) =>
                    imageData.image_id === action.payload.id ? action.payload.newImageData : imageData
                ),
                undoRedoByImage: nextUndoRedoByImage,
                undoIndexByImage: nextUndoIndexByImage,
            }
        }
        case Action.UPDATE_IMAGE_DATA_BATCH: {
            const replacements = new Map(action.payload.images.map(image => [image.image_id, image]));
            const undoImageId = action.payload.undoImageId;
            const undoImage = undoImageId ? replacements.get(undoImageId) : undefined;
            const currentStack = undoImageId ? state.undoRedoByImage[undoImageId] || [] : [];
            const currentUndoIndex = undoImageId ? state.undoIndexByImage[undoImageId] || 0 : 0;
            const recordUndo = Boolean(undoImageId && undoImage &&
                JSON.stringify(currentStack[currentUndoIndex]) !== JSON.stringify(undoImage));
            return {
                ...state,
                imagesData: state.imagesData.map(image => replacements.get(image.image_id) || image),
                undoRedoByImage: recordUndo ? {
                    ...state.undoRedoByImage,
                    [undoImageId!]: [undoImage!, ...currentStack.slice(currentUndoIndex, currentUndoIndex + 18)],
                } : state.undoRedoByImage,
                undoIndexByImage: recordUndo ? {
                    ...state.undoIndexByImage,
                    [undoImageId!]: 0,
                } : state.undoIndexByImage,
            };
        }
        case Action.ADD_IMAGES_DATA: {
            const mergedImages = state.imagesData.concat(action.payload.imageData);
            const nextUndoRedoByImage = { ...state.undoRedoByImage };
            const nextUndoIndexByImage = { ...state.undoIndexByImage };
            action.payload.imageData.forEach((imageData: ImageData) => {
                nextUndoRedoByImage[imageData.image_id] = [imageData];
                nextUndoIndexByImage[imageData.image_id] = 0;
            });
            return {
                ...state,
                imagesData: mergedImages,
                undoRedoByImage: nextUndoRedoByImage,
                undoIndexByImage: nextUndoIndexByImage,
                // imagesData: state.imagesData.concat(anotations)
            }
        }
        case Action.UPDATE_IMAGES_DATA: {
            const nextUndoRedoByImage: { [imageId: string]: ImageData[] } = {};
            const nextUndoIndexByImage: { [imageId: string]: number } = {};
            action.payload.imageData.forEach((imageData: ImageData) => {
                nextUndoRedoByImage[imageData.image_id] = [imageData];
                nextUndoIndexByImage[imageData.image_id] = 0;
            });
            return {
                ...state,
                imagesData: action.payload.imageData,
                undoRedoByImage: nextUndoRedoByImage,
                undoIndexByImage: nextUndoIndexByImage,
            }
        }
        case Action.SET_IMAGE_UNDO_INDEX: {
            return {
                ...state,
                undoIndexByImage: {
                    ...state.undoIndexByImage,
                    [action.payload.imageId]: action.payload.undoIndex,
                },
            };
        }
        case Action.UPDATE_LABEL_NAMES: {
            return {
                ...state,
                labels: action.payload.labels
            }
        }
        case Action.UPDATE_FIRST_LABEL_CREATED_FLAG: {
            return {
                ...state,
                firstLabelCreatedFlag: action.payload.firstLabelCreatedFlag
            }
        }
        case Action.UPDATE_ANNOTATION_COUNT:
            return {
                ...state,
                annotationCounts: action.payload.annotationCounts,
            };
        case Action.UPDATE_SAVESTATUS:
            return {
                ...state,
                UpdateSaveStatus: action.payload.UpdateSaveStatus,
            };
        case Action.UPDATE_AUDIO_URL:
            return { ...state, audioUrl: action.payload.audioUrl };

        case Action.UPDATE_ANNOTATIONS: {
            return {
                ...state,
                annotations: action.payload.annotations,
            };
            }

        case Action.UPDATE_VIDEO_TRACKING_ENABLED: {
            return {
                ...state,
                videoTrackingEnabled: action.payload.videoTrackingEnabled,
                // Clear reuse selection when turning tracking off
                pendingTrackId: action.payload.videoTrackingEnabled
                    ? state.pendingTrackId
                    : null,
            };
        }

        case Action.UPDATE_PENDING_TRACK_ID: {
            return {
                ...state,
                pendingTrackId: action.payload.pendingTrackId,
            };
        }
            
        default:
            return state;
    }
}
